import enrollService from './enroll'

export default {
  namespaced:true,
  modules:{
    enroll: enrollService
  }
}
